import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { Member } from '../../members.models';
import { NotifyService } from '../../../common/services/notify.service';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { saveMember } from '../../store/members/members.actions';
import { selectMembersErrors, selectMembersIsSubmittingFlag } from '../../store/members/members.selectors';

@Component({
  selector: 'member-form',
  template: `
    <div class="member-form">
      <div class="member-form-body">
        <xp-form-validation type="User" [name]="formName">
          <form id="memberForm" name="memberForm" #form="ngForm">
            <div class="form-group">
              <xp-form-group>
                <label for="email">{{ 'member.form.labels.email' | translate }}</label>
                <xp-input
                  id="email"
                  type="email"
                  name="email"
                  [(ngModel)]="item.email"
                  class="form-control"
                  placeholder="{{ 'member.form.placeholders.email' | translate }}"
                ></xp-input>
              </xp-form-group>
            </div>
          </form>
          <errors-notify [errors]="errorTexts"></errors-notify>
        </xp-form-validation>
      </div>
      <div class="member-form-footer modal-footer">
        <div class="modal-title-container">
          <h3 class="modal-title">{{ 'member.generic-object.title' | translate }}</h3>
        </div>

        <xp-submit-button
          (click)="createMember(item)"
          classNames="btn-lg btn-success pull-right"
          [createText]="'member.form.buttons.create' | translate"
          [isFormValid]="form.valid"
          [isFormSubmitting]="isSubmitting$ | async"
          *ngxPermissionsOnly="'updateProfile'"
        ></xp-submit-button>
      </div>
    </div>
  `,
})
export class MemberFormComponent extends BaseForm implements OnInit, BaseFormInterface {
  item: Partial<Member> = {};
  @ViewChild('form') form: NgForm;
  formName = 'memberForm';
  successMessageText = 'member.form.success_message';
  isSubmitting$ = this.store.select(selectMembersIsSubmittingFlag);
  errors$ = this.store.select(selectMembersErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
  ) {
    super();
  }

  createMember(member: Partial<Member>) {
    this.store.dispatch(saveMember({ member: { ...member } }));

    this.$rootScope.stateGo('app.account.settings.account.members');
  }
}
